import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a1dc9b7afefc000149cdf14_1783368793838_c28cdfa8/urbanhub/src/app/forgot-password/page.tsx");
